import {
  Button,
  Icon,
  Modal,
  OutlinedSelect,
  OutlinedSelectOptionType,
} from '@octano/global-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

type EquivalentOption = { id: number; code: string; name: string };

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: (equivalent: EquivalentOption) => void;
  options: EquivalentOption[];
};

const prefix = 'sectionList.equivalenceModal';

/**
 * Modal HU 15417: aparece cuando la asignatura seleccionada no tiene
 * secciones disponibles en el período y sí tiene asignaturas equivalentes
 * declaradas (`Course.compatibleWith`). Al confirmar, el caller hace el
 * swap del `selectedCourse` por la equivalente y persiste el origen via
 * `setEquivalenceOriginCourse`.
 */
const ModalEquivalenceSelection = ({
  isOpen,
  onCancel,
  onConfirm,
  options,
}: Props) => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState<
    OutlinedSelectOptionType | undefined
  >(undefined);

  const selectOptions: OutlinedSelectOptionType[] = options.map((c) => ({
    value: c.id,
    label: c.name,
  }));

  const handleConfirm = () => {
    if (!selectedOption) {
      return;
    }
    const equivalent = options.find((c) => c.id === selectedOption.value);
    if (equivalent) {
      onConfirm(equivalent);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onCancel}>
      <div className="text-center">
        <Row>
          <Col xs={12}>
            <Icon name="warning" size="50px" />
          </Col>
          <Col xs={12} className="pt-4">
            <span className="text-dark fs-22">{t(`${prefix}.title`)}</span>
          </Col>
          <Col xs={12} className="pt-3 pb-4">
            <span className="fs-18 text-light fw-300">
              {t(`${prefix}.subtitle`)}
            </span>
          </Col>
          <Col xs={12} className="pb-4 text-left">
            <OutlinedSelect
              isClearable={false}
              name="equivalenceCourseId"
              label={t(`${prefix}.selectLabel`)}
              options={selectOptions}
              value={selectedOption}
              onChange={(selected: OutlinedSelectOptionType) => {
                setSelectedOption(selected);
              }}
              menuPosition="fixed"
              menuShouldBlockScroll={true}
            />
          </Col>
          <Col xs={12} className="py-1 px-2">
            <Button
              fullwidth
              disabled={!selectedOption}
              onClick={handleConfirm}
              text={t(`${prefix}.confirm`)}
            />
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default ModalEquivalenceSelection;
